export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_TOGGLE_ALERT = 'FORGOT_PASSWORD_TOGGLE_ALERT';
export const FORGOT_PASSWORD_RESET = 'FORGOT_PASSWORD_RESET';